import { Modal } from '../modal/modal';
import { html } from 'lit';
import { MessageType } from '../alert/global-message.interface';

async function showConfirmInstructorModal(e?: Event, params?: {
  onConfirm?: () => void;
  onCancel?: () => void;
}): Promise<boolean> {
  const { onConfirm, onCancel } = params || {};
  return new Promise((resolve, _reject) => {
    const modal: Modal = new Modal({
      header: 'Are you an instructor?',
      body: {
        template: html` <mhecomm-alert
          id="instructor-confirmation-alert"
          type="${MessageType.warning}"
          message="<strong>Warning:</strong> Accounts created by non-instructors will not be validated and <strong>will prevent you from being able to purchase required course materials as a student.</strong>"
          data-automation-id="instructor-confirmation-modal-warning"
        ></mhecomm-alert>`,
      },
      primaryButton: { label: instructorModalPrimaryBtn },
      secondaryButton: { label: instructorModalSecondaryBtn },
      modalContext: { componentRef: 'instructor-confirmation-modal', componentRefData: {} },
    });

    modal.open(e);

    const onCloseModal = () => {
      modal.close();
      onCancel?.();
      resolve(false);
    };

    modal.addEventListener('mhecomm-modal-confirmed', () => {
      onConfirm?.();
      resolve(true);
      modal.removeEventListener('instructor-confirmation-modal-modal-close', onCloseModal);
      modal.close();
    });

    modal.addEventListener('instructor-confirmation-modal-modal-close', onCloseModal);
  });
}

const instructorModalPrimaryBtn = `Yes, I'm an instructor`;
const instructorModalSecondaryBtn = 'Cancel';

export { showConfirmInstructorModal, instructorModalPrimaryBtn, instructorModalSecondaryBtn };